import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SlideComponent = ({ actual, first, second, third, fourth }) => {
    const { t } = useTranslation();
    const [selectedButtonGroup1, setSelectedButtonGroup1] = useState(null);
    const [selectedButtonsGroup2, setSelectedButtonsGroup2] = useState({});

    useEffect(() => {
        const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '[]');
        if (savedAnswer.selectedButtonGroup2) setSelectedButtonGroup1(savedAnswer.selectedButtonGroup2);
        setSelectedButtonsGroup2({
            1: savedAnswer.selectedButtonGroup3,
            2: savedAnswer.selectedButtonGroup4,
            3: savedAnswer.selectedButtonGroup5,
        });
    }, []);

    const isSelected = (column, option) => selectedButtonsGroup2[column]?.includes(option);

    return (
        <div className="an-slide">
            <h2 className="an-slide-title">{t('olfactory.title')}</h2>

            <div className="an-section">
                <div className="an-section-title">{t('olfactory.intensity')}</div>
                <div className="an-buttons">
                    {first.question.map((item, index) => (
                        <span key={index} className={`an-btn${selectedButtonGroup1 === item.option ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
            </div>

            <div className="an-cols">
                <div className="an-col">
                    <div className="an-section-title">{t('olfactory.primary')}</div>
                    {second.question.map((item, index) => (
                        <span key={index} className={`an-btn${isSelected(1, item.option) ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
                <div className="an-col">
                    <div className="an-section-title">{t('olfactory.secondary')}</div>
                    {third.question.map((item, index) => (
                        <span key={index} className={`an-btn${isSelected(2, item.option) ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
                <div className="an-col">
                    <div className="an-section-title">{t('olfactory.tertiary')}</div>
                    {fourth.question.map((item, index) => (
                        <span key={index} className={`an-btn${isSelected(3, item.option) ? ' an-btn-selected' : ''}`}>
                            {item.option}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SlideComponent;
